import { UseState, ShallowEquals } from "react-vextensions";
import { E } from "js-vextensions";
import React, { useRef, useLayoutEffect, useCallback, Component, useEffect } from "react";
import ReactDOM from "react-dom";
import { GetSize, GetSize_Method } from "./Sizes.js";
// general
// ==========
// will try to finish this once I have more experience with react-hooks
/* export function UseCheckStillHoveredTimer() {
    let checkStillHoveredTimer;
    useEffect(()=>{
        checkStillHoveredTimer = new Timer(100, ()=>{
            const dom = GetDOM(this.root);
            if (dom == null) {
                checkStillHoveredTimer.Stop();
                return;
            }
            const mainRect = VRect.FromLTWH(dom.getBoundingClientRect());

            const leftBoxDOM = dom.querySelector(".NodeUI_LeftBox");
            const leftBoxRect = leftBoxDOM ? VRect.FromLTWH(leftBoxDOM.getBoundingClientRect()) : null;

            const mouseRect = new VRect(mousePos, new Vector2(1, 1));
            const intersectsOne = mouseRect.Intersects(mainRect) || (leftBoxRect && mouseRect.Intersects(leftBoxRect));
            // Log(`Main: ${mainRect} Mouse:${mousePos} Intersects one?:${intersectsOne}`);
            setHovered(intersectsOne);
        });
        return ()=>checkStillHoveredTimer.Stop(); // cleanup func
    }, []);
    return checkStillHoveredTimer;
} */
export class UseSize_Options {
    constructor() {
        this.method = GetSize_Method.OffsetSize;
    }
}
/**
 * Note that this does not update on window/css-only resizes; to detect a resize, the component calling UseSize must get re-rendered.
 * To detect resizes of any sort, try using/wrapping: https://github.com/ZeeCoder/use-resize-observer (or: https://github.com/jaredLunde/react-hook/tree/master/packages/size, or: https://github.com/rehooks/component-size)
 */
export function UseSize(options) {
    const opts = E(new UseSize_Options(), options);
    const [size, setSize] = UseState({ width: null, height: null }, ShallowEquals);
    //const [node, setNode] = UseState(null);
    const nodeRef = useRef(); // use ref, so that we don't trigger render just by storing newNode (setSize runs later than it anyway)
    const ref = useCallback(compOrNode => {
        if (compOrNode == null)
            return; // if element was unmounted, just ignore (ie. wait till remounted to call setSize)
        let newNode = compOrNode;
        if (compOrNode instanceof Component)
            newNode = ReactDOM.findDOMNode(compOrNode); // eslint-disable-line
        //setNode(newNode);
        nodeRef.current = newNode;
    }, []);
    useLayoutEffect(() => {
        if (nodeRef.current == null)
            return;
        window.requestAnimationFrame(() => {
            //const el = ref.current as HTMLElement;
            const newSize = GetSize(nodeRef.current, opts.method, opts.method_custom_sizeComps);
            setSize(newSize);
        });
        //}, [nodeRef.current]);
    });
    return [ref, size];
}
export function UseWindowEventListener(eventName, func, deps, listenerOptions) {
    useEffect(() => {
        window.addEventListener(eventName, func, listenerOptions);
        return () => window.removeEventListener(eventName, func, listenerOptions);
    }, deps);
}
export function UseDocumentEventListener(eventName, func, deps, listenerOptions) {
    useEffect(() => {
        document.addEventListener(eventName, func, listenerOptions);
        return () => document.removeEventListener(eventName, func, listenerOptions);
    }, deps);
}
// If we need more control over the options and such
// we can use  https://github.com/ZeeCoder/use-resize-observer as reference, it does the same thing
// using this library directly caused "ResizeObserver loop completed with undelivered notifications." error
export function useResizeObserver() {
    const [ref, setRef] = UseState(null);
    const [width, setWidth] = UseState(-1);
    const [height, setHeight] = UseState(-1);
    const observer = new ResizeObserver(entries => {
        requestAnimationFrame(() => {
            for (const entry of entries) {
                const { width, height } = entry.contentRect;
                setWidth(width);
                setHeight(height);
            }
        });
    });
    React.useEffect(() => {
        if (ref) {
            observer.observe(ref);
        }
        return () => observer.disconnect();
    }, [ref]);
    const refCb = React.useCallback(node => {
        if (node) {
            setRef(node);
        }
    }, []);
    return { ref: refCb, width, height };
}
//# sourceMappingURL=ReactHooks.js.map